import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import {Card, Col, Form, FormControl, Row, Tab, Table, Tabs} from 'react-bootstrap';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import Helmet from 'react-helmet';
import yts3glogo from './resources/ugyLogo.png';
import calllogo from './resources/ilet.png';
import ahtapotLogo from './resources/ahtabotLogo.png';
import 'react-toastify/dist/ReactToastify.css';
import TooltipDialog from "./ui/dialog/TooltipDialog";
import Tooltip from '@mui/material/Tooltip';
import {InfoTwoTone} from "@mui/icons-material";

import {
    ahtabotHeaderText,
    calculateUrl,
    connectionErrorMessage,
    defaultRequestDto,
    defaultViewDto,
    errorMessage,
    featureTypeListUrl,
    helmetTitle,
    helpdeskPhoneNumber,
    initUrl,
    maxCount,
    minimumDosyaCount,
    minimumDosyaCountId,
    minimumFeatureTypeSelectionMessage,
    minimumFeatureTypeSelectionMessageId,
    minimumTokenCount,
    minimumTokenCountId,
    minimumUserCount,
    minimumUserCountId,
    overFlowDosyaCountMessage,
    overFlowDosyaCountMessageId,
    presaleMaxFileCountUrl,
    ugyHeaderText
} from './data.js';
import AhtapotCalculationPanel from "./ahtapot/AhtapotCalculationPanel";
import UgyPlansYearly from "./ui/UgyPlansYearly";


function SubscriptionCalculator() {
    const [requestDto, setRequestDto] = useState(defaultRequestDto);
    const [actionCount, setActionCount] = useState(0);
    const [selectAllFeatures, setSelectAllFeatures] = useState(false);
    const [selectedSubscriptionFeatureTypeDtoList, setSelectedSubscriptionFeatureTypeDtoList] = useState([]);
    const [subscriptionFeatureTypeDtoList, setSubscriptionFeatureTypeDtoList] = useState([]);
    const [viewDto, setViewDto] = useState(defaultViewDto);
    const [featureCount, setFeatureCount] = useState(0);
    const [presaleMaxCount, setPresaleMaxCount] = useState(0);
    const [toolTipTitle, setToolTipTitle] = useState("");
    const [toolTipText, setToolTipText] = useState("");
    const [openTooltipModal, setOpenTooltipModal] = React.useState(false);
    const [selectedAhtabotTab, setSelectedAhtabotTab] = React.useState(true);

    const handleOpenTooltipModal = (item) => {
        if(item && item.tooltip){
            setToolTipTitle(item.name);
            setToolTipText(item.tooltip);
            setOpenTooltipModal(true);
        }
    };

    const handleCloseTooltipModal = () => {
        setOpenTooltipModal(false);
    };


    const handleSelectTabs = (eventKey) => {
        if(eventKey === "ahtabotTab"){
            setSelectedAhtabotTab(true);
        } else {
            setSelectedAhtabotTab(false);
        }
    };

    useEffect(() => {
        fetch(presaleMaxFileCountUrl)
            .then(res => res.json())
            .then((data) => {
                setPresaleMaxCount(data)
            }, (error) => {
                if (error) {
                    toast.error(connectionErrorMessage, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });

        fetch(featureTypeListUrl)
            .then(res => res.json())
            .then((data) => {
                setSubscriptionFeatureTypeDtoList(data)

                setTimeout(() => {

                    execInitUgyCalculator(data);
                }, 1000)

            }, (error) => {
                if (error) {
                    toast.error(connectionErrorMessage, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }

            });
    //  eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (actionCount > 0) {
            const timer = setTimeout(() => {
                if (featureCount <= 0) {
                    setViewDto(defaultViewDto);
                }

                onCompute();

            }, 500);

            return () => clearTimeout(timer);
        } else {
            fetch(initUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestDto)
            }).then(res => res.json())
                .then((data) => {
                    setViewDto(data)
                }, (error) => {
                    if (error) {
                        toast.error(connectionErrorMessage, {
                            position: toast.POSITION.TOP_CENTER
                        });
                    }
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actionCount]);

    const onChangeOpenUyapDosyaCount = (item) => {
        if (item.target.value >= 0 && item.target.value < maxCount) {
            setRequestDto({
                ...requestDto,
                openUyapDosyaCount: item.target.value
            });
            setActionCount(actionCount + 1);
        }
    };
    const onChangeTokenCount = (item) => {
        if (item.target.value >= 0 && item.target.value < maxCount) {
            setRequestDto({
                ...requestDto,
                tokenCount: item.target.value
            });
            setActionCount(actionCount + 1);
        }
    };
    const onChangeUserCount = (item) => {
        if (item.target.value >= 0 && item.target.value < maxCount) {
            setRequestDto({
                ...requestDto,
                userCount: item.target.value
            });
            setActionCount(actionCount + 1);
        }
    };

    const execInitUgyCalculator = (inSubscriptionFeatureTypeDtoList) => {
        let initSelected = ["CREATE_LFU_TASK"];
        if (inSubscriptionFeatureTypeDtoList.length > 0) {
            let selectedDtoList = [];
            inSubscriptionFeatureTypeDtoList.map(function (item) {
                if (item.active && item.subscriptionServiceFeatureCategoryTypeEnumValue === initSelected[0]) {
                    item.selected = true;
                    selectedDtoList.push(item);
                }
                return item;
            });
            setSubscriptionFeatureTypeDtoList(inSubscriptionFeatureTypeDtoList);
            setSelectedSubscriptionFeatureTypeDtoList(selectedDtoList);
            setFeatureCount(selectedDtoList.length);
            setActionCount(actionCount + 1);
        }
    };

    const onChangeFeatureAll = (itemChanged) => {
        if (itemChanged.target.checked) {
            let selectedDtoList = [];
            subscriptionFeatureTypeDtoList.map(function (item) {
                if (item.active) {
                    item.selected = true;
                    selectedDtoList.push(item);
                }
                return item;
            });
            setSubscriptionFeatureTypeDtoList(subscriptionFeatureTypeDtoList);
            setSelectedSubscriptionFeatureTypeDtoList(selectedDtoList);
            setSelectAllFeatures(true);
            setFeatureCount(selectedDtoList.length);
            setActionCount(actionCount + 1);
        } else {
            subscriptionFeatureTypeDtoList.map(function (item) {
                item.selected = false;
                return item;
            });
            setSubscriptionFeatureTypeDtoList(subscriptionFeatureTypeDtoList);
            setSelectedSubscriptionFeatureTypeDtoList([]);
            setSelectAllFeatures(false);
            setViewDto(defaultViewDto);
            setFeatureCount(0);
            setActionCount(actionCount + 1);
        }
    }

    const onChangeFeature = (itemChanged) => {
        let selectedSubscriptionFeatureTypeList = [];
        subscriptionFeatureTypeDtoList.map(function (item) {
            if (itemChanged.target.id.toString() === item.id.toString()) {
                item.selected = itemChanged.target.checked;
            }
            if (item.selected) {
                selectedSubscriptionFeatureTypeList.push(item);
            }
            return item;
        });
        setSubscriptionFeatureTypeDtoList(subscriptionFeatureTypeDtoList);
        setSelectedSubscriptionFeatureTypeDtoList(selectedSubscriptionFeatureTypeList);
        let newFeatureCount;
        if (itemChanged.target.checked) {
            newFeatureCount = featureCount + 1;
            setFeatureCount(newFeatureCount);
        } else {
            newFeatureCount = featureCount - 1;
            setFeatureCount(newFeatureCount);
        }

        if (newFeatureCount === 0) {
            setSelectAllFeatures(false);
        }
        setActionCount(actionCount + 1);
    };

    const onCompute = () => {
        let isAnySelectedFeatureType = false;
        let subscriptionFeatureTypeRequestDtoList = [];
        subscriptionFeatureTypeDtoList.map(function (item) {
            subscriptionFeatureTypeRequestDtoList.push({
                enumValue: item.enumValue,
                selected: item.selected
            });

            if (item.selected) {
                isAnySelectedFeatureType = true;
            }
            return item;
        });


        if (requestDto.openUyapDosyaCount > presaleMaxCount) {
            if (!toast.isActive(overFlowDosyaCountMessageId)) {
                toast.info(overFlowDosyaCountMessage, {
                    position: toast.POSITION.TOP_CENTER,
                    toastId: overFlowDosyaCountMessageId
                });

            }
            return;
        }

        if (!isAnySelectedFeatureType) {
            if (!toast.isActive(minimumFeatureTypeSelectionMessageId)) {
                toast.error(minimumFeatureTypeSelectionMessage, {
                    position: toast.POSITION.TOP_CENTER,
                    toastId: minimumFeatureTypeSelectionMessageId
                });
            }
            return;
        }

        if (!requestDto.openUyapDosyaCount || (parseInt(requestDto.openUyapDosyaCount) === 0)) {
            if (!toast.isActive(minimumDosyaCountId)) {
                toast.error(minimumDosyaCount, {
                    position: toast.POSITION.TOP_CENTER,
                    toastId: minimumDosyaCountId
                });
            }
            return;
        }

        if (!requestDto.tokenCount || (parseInt(requestDto.tokenCount) === 0)) {
            if (!toast.isActive(minimumTokenCountId)) {
                toast.error(minimumTokenCount, {
                    position: toast.POSITION.TOP_CENTER,
                    toastId: minimumTokenCountId
                });
            }
            return;
        }

        if (!requestDto.userCount || (parseInt(requestDto.userCount) === 0)) {
            if (!toast.isActive(minimumUserCountId)) {
                toast.error(minimumUserCount, {
                    position: toast.POSITION.TOP_CENTER,
                    toastId: minimumUserCountId
                });
            }
            return;
        }

        try {
            let newRequestDto = {...requestDto, subscriptionFeatureTypeRequestDtoList};

            fetch(calculateUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newRequestDto)
            }).then(res => res.json())
                .then((data) => {
                    setViewDto(data)
                }, (error) => {
                    if (error) {
                        toast.error(connectionErrorMessage, {
                            position: toast.POSITION.TOP_CENTER
                        });
                    }
                });

            window.scrollTo(0, 0);
        } catch (e) {
            toast.error(errorMessage);
        }
    }

    const GenereateSelectedFeature = () => {
        return (
            <React.Fragment>{
                selectedSubscriptionFeatureTypeDtoList.map(function (ozellikler) {
                    return (
                        <tr key={ozellikler.id || 'TR'}
                            style={{lineHeight: 2, height: "10px", fontSize: 12, verticalAlign: "middle"}}>
                            <td style={{verticalAlign: "middle"}}>
                                {ozellikler.subscriptionServiceFeatureCategoryTypeName}
                            </td>
                            <td style={{verticalAlign: "middle"}} title={ozellikler.tooltip}>

                                <> {ozellikler.name} </>
                            </td>
                        </tr>
                    )
                })
            }
            </React.Fragment>);
    };

    const GenereateFeature = () => {
        return (
            <React.Fragment>{
                subscriptionFeatureTypeDtoList.map(function (ozellikler) {
                    return (
                        <tr key={ozellikler.id || 'TR'}
                            style={{
                                lineHeight: 1.5,
                                height: "10px",
                                fontSize: 12,
                                verticalAlign: "middle"
                            }}>
                            <td>
                                <Form.Check
                                    type='checkbox'
                                    custom
                                    style={{"textAlign": "right", "verticalAlign": "right"}}
                                    id={ozellikler.id}
                                    checked={ozellikler.selected}
                                    disabled={!ozellikler.active}
                                    onChange={onChangeFeature}
                                />
                            </td>
                            <td style={ozellikler.active ? {verticalAlign: "middle", "whiteSpace": "nowrap"} : {
                                verticalAlign: "middle",
                                color: "lightgrey",
                                "whiteSpace": "nowrap"
                            }}>
                                {ozellikler.subscriptionServiceFeatureCategoryTypeName}
                            </td>
                            <td style={ozellikler.active ? {verticalAlign: "middle", "whiteSpace": "nowrap"} : {
                                verticalAlign: "middle",
                                color: "lightgrey",
                                "whiteSpace": "nowrap"
                            }}>
                                <div>{ozellikler.name}
                                    <Tooltip title={ozellikler.tooltip ? "" : "Bilgi Yok"} aria-label="add">
                                        <InfoTwoTone style={{color: "rgb(0, 0, 139)",float: "right"}} onClick={() => handleOpenTooltipModal(ozellikler)} />
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                    )
                })
            }
            </React.Fragment>);
    };


    const HeaderPart = () => {
        return (
            <Row>
                {selectedAhtabotTab ? <Col lg={6} style={{"whiteSpace": "nowrap"}}>
                    <img src={ahtapotLogo} style={{padding:5, height: 75, width: 120}} alt="Logo"/> {ahtabotHeaderText}
                </Col> : <Col lg={6} style={{"whiteSpace": "nowrap"}}>
                <img src={yts3glogo} style={{height: 75, width: 75}} alt="Logo"/> {ugyHeaderText}
                </Col>}
                <Col lg={{span: 3, offset: 3}} className="d-none d-lg-block">
                    <Row
                        className="justify-content-end p-3 align-text-bottom align-middle align-items-center">
                        <Form.Label className="pr-3 align-middle">
                            {helpdeskPhoneNumber}
                        </Form.Label>
                        <img src={calllogo} alt="callLogo" width={50} height={50}/>
                    </Row>
                </Col>
            </Row>
        );
    };

    const UgyCalculationResultPart = (props) => {
        const [selectedEnumValue, setSelectedEnumValue] = useState(null);
        return (<UgyPlansYearly ugyDto={props?.viewDto}
                                enableCheckBoxIcon={false}
                                selectedId={selectedEnumValue}
                                setSelectedEnumValue={setSelectedEnumValue}/>);
    };

    return (
        <div className="overflow-hidden containerWrapper">
            <Helmet>
                <title>{helmetTitle}</title>
            </Helmet>
            <Col lg={12} style={{padding: "0"}}>
                <Card>
                    <Card.Header as="h5" style={{height: 85}}
                                 className="align-items-center align-middle p-1 font-weight-bold">
                        <HeaderPart/>
                    </Card.Header>
                </Card>
            </Col>

            <Tabs
                onSelect={(eventKey) => handleSelectTabs(eventKey)}
                className="pt-1 pl-3 tabsColor"
                id="subscription-tabs">
                <Tab eventKey="ahtabotTab" title="Ahtabot">
                    <Row style={{fontSize: 16}}>
                        <Col lg={12}>
                            <Card>
                                <Card.Body className="font-weight-bold pt-3 pb-1">
                                    <AhtapotCalculationPanel viewDto={viewDto}/>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="ugyTab" title="UGY">
                    <Row style={{fontSize: 16}}>
                        <Col lg={12}>
                            <Card>
                                <Card.Body className="font-weight-bold pt-3 pb-1" style={{height: 300}}>
                                    <UgyCalculationResultPart viewDto={viewDto}/>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                    <div style={{
                            width: "20%",
                            paddingLeft: "35px"
                        }} >
                            <Card>
                                <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                                           style={{fontSize: 12}}>
                                    <Table striped bordered hover responsive size="sm">
                                        <tbody>
                                        <tr style={{height: 10}}>
                                            <td style={{
                                                width: "55%"
                                            }}>
                                            </td>
                                            <td style={{
                                                height: 10,
                                                "textAlign": "center",
                                                "verticalAlign": "middle"
                                            }}>
                                                <Form.Label style={{height: 10}}>
                                                    Adet
                                                </Form.Label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <Form.Label className="pl-1 align-middle"
                                                            style={{"whiteSpace": "nowrap"}}>
                                                    İşlem Yapılacak Dosya Sayısı
                                                </Form.Label>
                                            </td>
                                            <td className="justify-content-end" style={{"whiteSpace": "nowrap"}}>
                                                <FormControl type='number'
                                                             className="text-right justify-content-end pl-4"
                                                             placeholder="Adet"
                                                             style={{fontSize: 10}}
                                                             value={requestDto.openUyapDosyaCount}
                                                             onChange={onChangeOpenUyapDosyaCount}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <Form.Label className="align-middle pl-1">
                                                    TOKEN'lı Avukat Sayısı
                                                </Form.Label>
                                            </td>
                                            <td>
                                                <FormControl
                                                    type='number'
                                                    placeholder="Adet"
                                                    className="text-right pl-4"
                                                    style={{fontSize: 10}}
                                                    value={requestDto.tokenCount}
                                                    onChange={onChangeTokenCount}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <Form.Label className="align-middle pl-1">
                                                    Kullanıcı Sayısı
                                                </Form.Label>
                                            </td>
                                            <td>
                                                <div className="justify-content-end align-middle ">
                                                    <FormControl
                                                        placeholder="Adet"
                                                        type='number'
                                                        className="text-right align-items-end pl-4"
                                                        style={{fontSize: 10}}
                                                        value={requestDto.userCount}
                                                        onChange={onChangeUserCount}
                                                    />
                                                </div>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <Form.Label className="align-middle pl-1" style={{height: 10}}>
                                                    Özellik Sayısı
                                                </Form.Label>
                                            </td>
                                            <td style={{"textAlign": "end", "verticalAlign": "middle"}}>
                                                <FormControl
                                                    type='number'
                                                    disabled={true}
                                                    className="text-right align-items-end pl-4"
                                                    style={{fontSize: 10}}
                                                    value={featureCount}
                                                />
                                            </td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </div>
                        <div style={{
                            width: "45%"
                        }} className="pl-0 pr-0">
                            <Card>
                                <Card.Body className="p-1">
                                    <div style={{height: "65vh", overflowY: "scroll", border: "black"}}>
                                        <Table striped bordered hover size="sm">
                                            <thead>
                                            <tr style={{"fontSize": 12, "fontWeight": "bold", color: "#00008B"}}>
                                                <th style={{"fontSize": 12, width: "5%"}}>
                                                    <Form.Check
                                                        type='checkbox'
                                                        custom
                                                        style={{"textAlign": "right", "verticalAlign": "right"}}
                                                        id="selectAllFeaturesId"
                                                        checked={selectAllFeatures}
                                                        onChange={onChangeFeatureAll}
                                                    />
                                                </th>
                                                <th style={{
                                                    "verticalAlign": "middle",
                                                    "textAlign": "center",
                                                    "whiteSpace": "nowrap"
                                                }}>
                                                    Özellik Kategorisi
                                                </th>
                                                <th style={{
                                                    "verticalAlign": "middle",
                                                    "textAlign": "center",
                                                    "whiteSpace": "nowrap"
                                                }}>
                                                    Özellik Adı
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody className="align-items-center align-middle">
                                            <GenereateFeature/>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                        <div style={{
                            width: "35%"
                        }} className="pr-3 pl-0">
                            <Card>
                                <Card.Body className="p-1">
                                    <div style={{height: "65vh", overflowY: "scroll", border: "black"}}>
                                        <Table striped bordered hover responsive size="sm">
                                            <thead>
                                            <tr style={{"fontSize": 12, "fontWeight": "bold", color: "#00008B"}}>
                                                <th style={{
                                                    "verticalAlign": "middle",
                                                    "textAlign": "center",
                                                    width: "40%",
                                                    "whiteSpace": "nowrap"
                                                }}>
                                                    Seçilen Özellik Kategorisi
                                                </th>
                                                <th style={{
                                                    "verticalAlign": "middle",
                                                    "textAlign": "center",
                                                    width: "60%",
                                                    "whiteSpace": "nowrap"
                                                }}>
                                                    Seçilen Özellik Adı
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody className="align-items-center align-middle">
                                            <GenereateSelectedFeature/>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </Row>
                    <TooltipDialog
                        open = {openTooltipModal}
                        handleClose = {handleCloseTooltipModal}
                        title = {toolTipTitle}
                        text = {toolTipText}
                    />
                </Tab>
            </Tabs>
        </div>
    );
}

export default SubscriptionCalculator;
